import { ComposeViewState } from 'owa-mail-compose-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('removeAppendOnSend', (viewState: ComposeViewState) => {
    viewState.appendOnSend = [];
});
